Spruce.store(
  "pt",
  {
    name: null,
    colors: [],
    selection: [],
    completed: false,
    skiped: false,
    isComplete() {
      return this.name && this.completed && !this.skiped;
    },
    has(identifier) {
      return this.colors.includes(identifier);
    },
    skip() {
      this.name = null;
      this.colors = [];
      this.selection = [];
      this.completed = false;
      this.skiped = true;
    },
    data(name, colors, selection) {
      this.name = name;
      this.colors = colors;
      this.selection = selection;
      this.completed = true;
      this.skiped = false;
    },
  },
  true
);
